import { useMinWidthTailwindBreakpoints } from "components/ui/hooks/useTailwindBreakpoints";
import { useMediaQuery } from "usehooks-ts";

export function useIsPossiblyMobileDevice() {
  const breakpoints = useMinWidthTailwindBreakpoints();
  return Object.values(breakpoints).every((breakpoint) => !breakpoint);
}

export function useHasPointer() {
  return useMediaQuery("(pointer: fine)");
}

export function useIsMobileDevice() {
  const isPossible = useIsPossiblyMobileDevice();
  const hasPointer = useHasPointer();
  return isPossible && hasPointer;
}
